/**
 * What: Renders the dedicated Shopify page for recent Web Pixel operational activity.
 * Transport / data-flow: Browser-only composition over `/api/web-pixel/activity` through `WebPixelActivityLogCard`.
 *
 */
import { WebPixelActivityLogCard } from './WebPixelActivityLogCard'
import type { shopifyApiFetch } from '../../shopifyApiFetch'
import { shopifyComponentCopy } from '@testfeed/product-language'
import { FooterHelp, HelpModal } from '../shared/PageHelp'

const HELP_MODAL = 'web-pixel-activity-help-modal'

type WebPixelActivityPageProps = {
  shopify: Parameters<typeof shopifyApiFetch>[0]
}

/** Keeps Pixel event diagnostics separate from configuration-oriented settings controls. */
export function WebPixelActivityPage({ shopify }: WebPixelActivityPageProps) {
  const copy = shopifyComponentCopy.webPixelActivityWebPixelActivityPage
  return (
    <s-stack direction="block" gap="large-200">
      <s-stack direction="block" gap="small-100">
        <s-heading>{copy.storefrontWebPixelActivity001}</s-heading>
        <s-text color="subdued">{copy.reviewTheLatestWebPixel002}</s-text>
      </s-stack>
      <WebPixelActivityLogCard shopify={shopify} />
      <FooterHelp modalId={HELP_MODAL} link="what this tracks" />
      <HelpModal id={HELP_MODAL} heading={copy.helpModalHeading}>
        <s-paragraph>{copy.helpModalBody1}</s-paragraph>
        <s-paragraph color="subdued">{copy.helpModalBody2}</s-paragraph>
      </HelpModal>
    </s-stack>
  )
}
